export type WorkflowHistorySnapshot = {
  status?: "warming" | "ready";
  points?: unknown[];
};

export function isWorkflowHistoryWarming(snapshot: WorkflowHistorySnapshot | undefined): boolean {
  return snapshot?.status === "warming";
}
